<template lang="pug">
.send-message-form
  .contents.d-flex.flex-wrap.align-items-start
    .register-body
      //- error message
      .register-row(v-if="errorMessage != ''")
        .register-group
          span.error-message {{ errorMessage }}
      .register-row
        .register-group
          .register-key
            span.key-name 宛先種別
            span.validation-label 必須
          .register-value
            label.register-radio-label(v-if="_enableUseSendTargetToAllWaiter")
              input#type-0.register-radio-form(v-model="type" name="type" type="radio" value=4 v-validate="{ required: true }" data-vv-as="宛先種別")
              span.register-radio-text 入所申込者全員
            label.register-radio-label(v-if="_enableUseSendTargetToWaiter")
              input#type-1.register-radio-form(v-model="type" name="type" type="radio" value=5)
              span.register-radio-text 入所申込者個別
          .error-messages(v-if="errors.has('type')")
            div(v-for="error in errors.collect('type')")
              label.error-message {{ error }}
      //- target button
      .register-row(v-show="type == 5")
        .register-group
          .register-key
            span.key-name 宛先
            span.validation-label 必須
          .register-value.flex-wrap.send-targets
            .loading(v-if="isWaiterBusy")
              b-spinner.spinner
              span 宛先読込中...
            button.btn.send-target-select-btn(v-else @click="showWaiterSelectModal") 宛先選択
            template(v-for="waiter in waiterTargets")
              .send-target.d-flex(v-for="family in waiter.families" v-if="family.isTarget")
                span.target-name.align-self-center {{ family.familyName }}{{ getSenderType(family.senderType) }}
                b-badge.delete-btn.align-self-center(variant="secondary" @click="deleteWaiterTarget(family)") X
          .error-messages(v-if="errors.has('message-waiter-targets')")
            div(v-for="error in errors.collect('message-waiter-targets')")
              label.error-message {{ error }}
      //- tempates
      FormInputSelect(v-model="templateId" key-name="テンプレート" name="template-id" :options="templateOptions" :styles="{ 'width': '600px' }")
      //- title & text
      .register-row
        .register-group
          .register-key
            span.key-name タイトル
            span.validation-label 必須
          .register-value
            input#message-title.register-form(
              v-model="title"
              type="text"
              placeholder="タイトル"
              name="message-title"
              v-validate="{ required: true, max: 100 }"
              data-vv-as="タイトル"
              maxlength="100"
              :class="{ noinput: !title }"
            )
          .error-messages(v-if="errors.has('message-title')")
            div(v-for="error in errors.collect('message-title')")
              label.error-message {{ error }}
              br
      .register-row
        .register-group
          .register-key
            .left-side.d-flex
              span.key-name 本文
              span.validation-label 必須
            .right-side
              HelpIcon(popoverId="message-url-help" title="リンクの記載について")
                template(v-slot:text)
                  span メッセージ内でURLリンクを使用したい場合は、改行してURLを記載することでリンクを送ることができます。
                  br
                  span 実際に送られるLINEメッセージは送信ボタン押下時のプレビューをご確認ください。
                  br
                  br
                  strong 記載例
                  br
                  span 以下のリンクからコニカミノルタへアクセスしてください。
                  br
                  span https://www.konicaminolta.com
                  br
                  br
                  strong リンク名を付ける方法
                  br
                  span 以下のようにリンク名とURLを記載すると、リンク名を表示することができます。
                  br
                  span [リンク名](URL)
                  br
                  br
                  strong 記載例（リンク名を付ける方法）
                  br
                  span [HitomeQ](https://konicaminolta.com)
          .register-value 
            textarea#text.register-form(
              v-model="text"
              placeholder="本文"
              name="text"
              v-validate="{ required: true, max: 1000 }"
              data-vv-as="本文"
              maxlength="1000"
              rows="7"
              :class="{ noinput: !text }"
            )
          .error-messages(v-if="errors.has('text')")
            div(v-for="error in errors.collect('text')")
              label.error-message {{ error }}
              br
      //- option buttons
      .checkboxs.d-flex.flex-row.flex-wrap
        FormCheck.option-button.add-read(
          v-model="addReadButton"
          key-name="見ましたボタン"
          name="add-read"
          label="つける"
          @onClick="onAddReadCheck(addReadButton)"
        )
        FormCheck.option-button.option-text(
          v-model="addOptionText"
          key-name="既読確認メッセージ"
          name="option-text"
          label="つける"
          :active="addReadButton"
          :disabled="!addReadButton"
        )
          template(v-slot:question)
            HelpIcon(popoverId="message-set-confirm" title="既読確認メッセージについて")
              template(v-slot:text)
                span チェックをつけることでLINEメッセージの見ましたボタンの強調メッセージを付与します。
                br
                span 実際に送られるLINEメッセージは送信ボタン押下時のプレビューをご確認ください。
                br
                br
                strong 付与されるメッセージ
                br
                span.option-text 「見ました」が押されなかった場合、施設から連絡をさせて頂く場合があります。
        FormCheck.option-button.reply-btn(
          v-model="addReplyButton"
          key-name="返信ボタン"
          name="add-reply-button"
          label="つける"
        )
    //- temp files
    .register-body
      .register-row
        .register-group
          .register-key
            .left-side.d-flex
              span.key-name 添付ファイル
              span.comment ※最大9ファイルまで登録可能です
            .right-side
              HelpIcon(popoverId="temp-files-help" :title="'選択可能なファイルについて'")
                template(#text)
                  span 選択可能なファイルは、写真（jpeg）、動画（mp4もしくはmov）、pdfです。
                  br
                  span pdfはそのまま送るか、画像に変換して送るかをファイルごとに選択できます。
                  span 画像に変換した場合は、LINEですぐに見ることができます。
                  br
                  span 送信可能な動画のファイルサイズは200MB未満、pdfは50MB未満です。
                  br
                  span ファイルサイズが大きいと送信に時間がかかりますので、なるべく小さいサイズにしてください。
          .register-value
            .d-flex.flex-column
              MultiFileSelecter(
                ref="fileSelecter"
                :mimetypes="['video/quicktime', 'video/mp4', 'image/jpeg', 'application/pdf']"
                width="450px"
                height="74px"
                :limit="_registerImageFilesLimit"
                :showPreview="true"
                :enablePreviewStatus="_enablePreviewStatus"
                @input="inputFiles"
                @preview="onTempFilePreview"
              )
              label.need-convert-pdf
                input(v-model="needConvertPdf" name="need-convert-pdf" type="checkbox")
                span.text PDFファイルの場合、画像に変換する
              input(name="tempfiles-multiple-register-errors" data-vv-as="添付ファイル" style="display: none")
              .error-messages.text-break(v-for="error in errors.collect('tempfiles-multiple-register-errors')" :style="{ 'maxWidth': '500px' }")
                label.error-message {{ error }}
                br
      .register-row
        DraggableFiles(v-model="files" @delete="onFileDelete" :item-width="'468px'")

  .box-footer.register-footer
    ValidationAlert(v-model="showValidationAlert")

    button.btn.preview-btn(type="button" @click="onMessagePreview") プレビュー

    .buttons.m-0
      button#save-draft-btn.btn(type="button" @click="onSaveDraftMessage" :class="{ 'disable': _disableUseSaveDraftMessage }") 下書き保存
      button.btn.send-message-btn(type="button" @click="sendMessageConfirm"
        :class="{ 'disable': _disableUseSendAndReply }" :disabled="_disableUseSendAndReply") 送信

  SendMessageWaiterSelectModal(ref="sendWaiterSelectModal" @add="addSendWaiterTarget")
  SendMessageFilePreviewModal(ref="previewModal")
  SendMessageModal(ref="messageConfirmModal" :files="files" @preview="onTempFilePreview" @submit="sendMessage")
  OkCancelModal(v-model="showConfirmDraftMessageModal" title="下書きを保存します。よろしいですか？" @ok="saveDraftMessage")

  PageLoading(:isBusy="isLoading" :message="loadingMessage")
</template>

<script lang="ts">
import { Component, Watch, Inject, Vue } from "vue-property-decorator";
import draggable from "vuedraggable";
import { userStore, screenInputTemporaryStore } from "@/store/store";
import { needRefreshesStore } from "@/store/store";
import { PcUrl } from "@/commons/constants/PcUrl";

import CustomValidate from "@/commons/utils/CustomValidate";
import Setting from "../../../../public/setting.json";
import { SenderType } from "@/commons/models/Resident";
import WaiterFamiliesService, { WaiterFamiliesGetModel } from "@/commons/services/WaiterFamilies";
import { SendMessageTargetResident, SendTargetFamily } from "@/commons/models/SendMessageTarget";
import { LineReceiverDetail } from "@/commons/models/SendLineMessage";
import { SendMessageFunction } from "@/commons/models/Message";
import SendMessageFormCommonService from "@/commons/services/SendMessageFormCommon";
import { DraftMessageFile, DraftMessagesGetModel, DraftMessagesPatchModel, DraftMessagesPostModel } from "@/commons/services/DraftMessages";
import S3UrlService from "@/commons/services/S3Url";
import SendMessageTemplatesService, { SendMessageTemplatesGetModel, TemplateType } from "@/commons/services/SendMessageTemplates";

import OkCancelModal from "@/pc/basics/OkCancelModal.vue";
import HelpIcon from "@/pc/basics/HelpIcon.vue";
import MultiFileSelecter from "@/pc/basics/MultiFileSelecter.vue";
import FormCheck from "@/pc/components/forms/FormCheck.vue";
import DraggableFiles, { ExtDraggableFile } from "@/pc/components/ExtDraggableFiles.vue";
import SendMessageWaiterSelectModal from "@/pc/components/modals/SendMessageWaiterSelectModal.vue";
import SendMessageModal from "@/pc/components/modals/SendMessageModal.vue";
import SendMessageFilePreviewModal from "@/pc/components/modals/SendMessageFilePreviewModal.vue";
import FormInputSelect from "@/pc/components/forms/FormInputSelect.vue";
import Loading from "@/pc/basics/Loading.vue";
import PageLoading from "@/pc/basics/PageLoading.vue";
import ValidationAlert from "@/pc/basics/ValidationAlertByValidator.vue";
import { SendLineMessagesPostModel } from "@/commons/services/SendLineMessages";
import { SendMailMessagesPostModel } from "@/commons/services/SendMailMessages";

/**
 * メッセージ送信フォームコンポーネント
 */
@Component({
  components: {
    draggable,
    SendMessageWaiterSelectModal,
    SendMessageModal,
    FormCheck,
    MultiFileSelecter,
    DraggableFiles,
    SendMessageFilePreviewModal,
    HelpIcon,
    FormInputSelect,
    Loading,
    OkCancelModal,
    PageLoading,
    ValidationAlert
  },
  $_veeValidate: { validator: "new" }
})
export default class MessageFormTab extends Vue {
  /** 待機者家族サービス */
  @Inject("WaiterFamiliesService") waiterFamiliesService!: WaiterFamiliesService;
  /** メッセージ送信テンプレートサービス */
  @Inject("SendMessageTemplatesService") sendMessageTemplatesService!: SendMessageTemplatesService;
  /** S3Urlサービス */
  @Inject("S3UrlService") s3UrlService!: S3UrlService;

  /** ページ全体ローディング表示可否 */
  isLoading: boolean = false;
  /** ローディングメッセージ */
  loadingMessage: string = "";
  /** 下書き保存確認モーダル表示可否 */
  showConfirmDraftMessageModal: boolean = false;
  /** エラーメッセージ */
  errorMessage: string = "";

  /** バリデーションアラート表示可否 */
  showValidationAlert: boolean = false;

  /** 宛先種別 */
  type: string = "";
  /** 宛先(入居申込者) */
  waiterTargets: Array<SendMessageTargetResident> = [];
  /** 宛先読込み中(入居申込者) */
  isWaiterBusy: boolean = true;
  /** 入居申込者全員に送信で使用する、全家族 */
  allWaiterFamily: Array<WaiterFamiliesGetModel> = [];

  /** 使用するメッセージ送信テンプレート */
  templateId: number = 0;
  /** メッセージ送信テンプレート選択肢 */
  templateOptions: Array<{ value: number; label: string }> = [];
  /** メッセージ送信テンプレートMAP */
  templateIdMap: Map<number, SendMessageTemplatesGetModel> = new Map();

  /** 送信メッセージタイトル */
  title: string = "";
  /** 送信メッセージ本文 */
  text: string = "";
  /** メッセージの返信が欲しいことを強調させるか */
  addOptionText: boolean = false;
  /** 見ましたをつけるか */
  addReadButton: boolean = false;
  /** 返信をつけるか */
  addReplyButton: boolean = false;
  /** 実際に登録するファイル */
  files: Array<ExtDraggableFile> = [];
  /** メッセージ下書きID。メッセージ下書きの「編集」で復元をした場合のみ値が格納される */
  draftMessageId: number | null = null;
  /** メッセージ下書き旧添付ファイル。メッセージ下書きの「編集」で復元をした場合のみ値が格納される */
  draftMessageOldFiles: Array<DraftMessageFile> | null = null;
  /** メッセージ下書き更新日時。メッセージ下書きの「編集」で復元をした場合のみ値が格納される */
  draftMessageUpdated: number | null = null;

  /** 添付ファイルのPDFを変換するか否か */
  needConvertPdf: boolean = false;

  /** ファイル登録数 */
  readonly registerFileUploadLimit: number = 9;

  get _enableUseSendTargetToAllWaiter(): boolean {
    return userStore.user.permissions.functions.waiterSendMessagesFunction && userStore.loginUser.permissions.sendMessagesFunction.useSendTargetToAllWaiter;
  }

  get _enableUseSendTargetToWaiter(): boolean {
    return userStore.user.permissions.functions.waiterSendMessagesFunction && userStore.loginUser.permissions.sendMessagesFunction.useSendTargetToWaiter;
  }

  get _disableUseSaveDraftMessage(): boolean {
    return !userStore.loginUser.permissions.sendMessagesFunction.useSaveDraftMessage;
  }

  get _disableUseSendAndReply(): boolean {
    return !userStore.loginUser.permissions.sendMessagesFunction.useSendAndReply || (!this._enableUseSendTargetToAllWaiter && !this._enableUseSendTargetToWaiter);
  }

  @Watch("needConvertPdf")
  public changeNeedConvertPdf(needConvertPdf: boolean): void {
    this.setCookie(needConvertPdf);
    return;
  }

  @Watch("templateId")
  public changeTemplateId(newTemplateId: number): void {
    if (newTemplateId == 0) {
      this.title = "";
      this.text = "";
      this.addOptionText = false;
      this.addReadButton = false;
      this.addReplyButton = false;
    }

    const selectedTemplate: SendMessageTemplatesGetModel | undefined = this.templateIdMap.get(newTemplateId);
    if (selectedTemplate == undefined) {
      return;
    }

    this.title = selectedTemplate.title ? selectedTemplate.title : "";
    this.text = selectedTemplate.text ? selectedTemplate.text : "";
    this.addOptionText = selectedTemplate.addOptionText;
    this.addReadButton = selectedTemplate.addReadButton;
    this.addReplyButton = selectedTemplate.addReplyButton;

    return;
  }

  /**
   * ### 画面の作り直し
   */
  public async refresh(): Promise<void> {
    await this.initialize();
    return;
  }

  /** ### ファイルをリセットする */
  public resetFiles(): void {
    this.files = [];
    return;
  }

  /**
   * ### 画面の作り直し
   */
  public async refreshByNoLoading(): Promise<void> {
    try {
      this.initializeForm();
    } catch (error) {
      // 処理中に画面遷移が発生した場合、エラーと見なさないためURLチェックする
      if (this.$route.fullPath != PcUrl.SendMessage) {
        return;
      } else {
        throw error;
      }
    }
    return;
  }

  /**
   * ### エラーメッセージを設定する
   *
   * - 親コンポーネントで登録処理をしてエラーが発生した場合に呼び出される
   */
  public setErrorMessage(message: string): void {
    this.errorMessage = message;
    return;
  }

  /**
   * ### 1ページあたりの表示行数をCookieに設定する
   */
  public setCookie(needConvertPdf: boolean): void {
    // Cookie有効秒数。有効期限は必ず設定しないといけないので、10年分にしておく
    const saveSecond = 10 * 365 * 24 * 60 * 60;
    document.cookie = `send-message-form-need-convert-pdf=${needConvertPdf}; max-age=${saveSecond};`;
    return;
  }

  /**
   * ### vue lifecycle created
   */
  public created() {
    CustomValidate.addCustomValidate(this.$validator);
    return;
  }

  /**
   * ### vue lifecycle mounted
   */
  public async mounted(): Promise<void> {
    // PDFの変換可否はCookieから取得する。取得できない場合はデフォルト値を使用する
    const needConvertPdf: boolean | null = this.loadCookie();
    this.needConvertPdf = needConvertPdf != null ? needConvertPdf : false;

    await this.initialize();

    return;
  }

  public async initialize(): Promise<void> {
    this.isLoading = true;
    this.loadingMessage = "読込み中...";

    this.initializeForm();
    await this.initilizeTemplate();
    await this.createView();

    this.isLoading = false;

    return;
  }

  public initializeForm(): void {
    // input要素の内容を初期化
    this.type = "";
    this.title = "";
    this.text = "";
    this.files = [];
    this.templateId = 0;
    this.addOptionText = false;
    this.addReadButton = false;
    this.addReplyButton = false;
    this.draftMessageId = null;
    this.draftMessageOldFiles = null;
    this.draftMessageUpdated = null;

    for (const group of this.waiterTargets) {
      for (const family of group.families) {
        family.isTarget = false;
      }
    }

    return;
  }

  public async initilizeTemplate(): Promise<void> {
    // メッセージ送信テンプレートを取得して選択肢、MAPを作成する
    const sendMessageTemplates: Array<SendMessageTemplatesGetModel> = await this.getSendMessageTemplates();
    const templateOptions: Array<{ value: number; label: string }> = this.createTemplateOpstions(sendMessageTemplates);
    this.templateOptions = templateOptions;
    const templateIdMap: Map<number, SendMessageTemplatesGetModel> = this.createTemplateIdMap(sendMessageTemplates);
    this.templateIdMap = templateIdMap;
    return;
  }

  /**
   * ### Cookieを見て、値が保持されている場合はCookieの値を返す
   */
  public loadCookie(): boolean | null {
    if (document.cookie) {
      let cookieMap: any = {};
      let cookies: Array<string> = document.cookie.split("; ");
      cookies.forEach(function (value) {
        //cookie名と値に分ける
        let content = value.split("=");
        cookieMap[content[0]] = content[1];
      });

      // cookieに値が格納されていないとundefinedが格納されているが、実際にはゴミデータが格納されているので文字列チェックが必要
      const needConvertPdf: string = cookieMap["send-message-form-need-convert-pdf"];

      if (needConvertPdf == "true") {
        return true;
      } else if (needConvertPdf == "false") {
        return false;
      } else {
        return null;
      }
    }

    return null;
  }

  /**
   * ### メッセージ送信テンプレートを取得する
   */
  public async getSendMessageTemplates(): Promise<Array<SendMessageTemplatesGetModel>> {
    const results: Array<SendMessageTemplatesGetModel> = await this.sendMessageTemplatesService.gets(userStore);
    return results;
  }

  /**
   * ### メッセージ送信テンプレートの選択肢を作成する
   */
  public createTemplateOpstions(templates: Array<SendMessageTemplatesGetModel>): Array<{ value: number; label: string }> {
    let options: Array<{ value: number; label: string }> = [];

    options.push({ value: 0, label: `使用しない` });

    for (const template of templates) {
      if (template.templateType == TemplateType.WAITER_MESSAGE) {
        options.push({ value: template.id, label: template.name });
      }
    }

    return options;
  }

  /**
   * ### テンプレートIDのMAPを作成する
   */
  public createTemplateIdMap(templates: Array<SendMessageTemplatesGetModel>): Map<number, SendMessageTemplatesGetModel> {
    let map: Map<number, SendMessageTemplatesGetModel> = new Map<number, SendMessageTemplatesGetModel>();

    for (const template of templates) {
      map.set(template.id, template);
    }

    return map;
  }

  /**
   * ### 画面表示情報を作成する
   *
   * - エラーメッセージの初期化
   * - 入居申込者の作成
   */
  public async createView(): Promise<void> {
    this.errorMessage = "";

    this.isWaiterBusy = true;

    const waiterTargets: Array<SendMessageTargetResident> = await this.createWaiterTargets();
    this.waiterTargets = waiterTargets;
    const allWaiterFamily: Array<WaiterFamiliesGetModel> = await this.getWaiterFamilies();
    this.allWaiterFamily = allWaiterFamily;

    // storeに一時保存した入力内容を復元する
    this.restoreScreenInputTemporaryStore();

    this.isWaiterBusy = false;

    return;
  }

  /**
   * ### 待機者宛先対象リストを作成する
   *
   * - 待機者(利用者)-家族でネストして画面表示するため、構成を合わせる
   * - APIから家族を取得すると、家族にひもづく待機者(利用者)の情報もついてくるので、家族を取得するだけで情報は作れる
   */
  public async createWaiterTargets(): Promise<Array<SendMessageTargetResident>> {
    // 宛先対象の元となる家族を取得する
    // 0件なら宛先対象は空配列を返す
    const families: Array<WaiterFamiliesGetModel> = await this.getWaiterFamilies();
    if (families.length == 0) {
      return [];
    }

    let targetResidents: Array<SendMessageTargetResident> = [];
    let residentId: number = families[0].id ? families[0].id : -1;
    let targetResident: SendMessageTargetResident = this.createTargetWaiter(families[0]);

    for (let i = 1; i < families.length; i++) {
      const family: WaiterFamiliesGetModel = families[i];

      // 利用者が変わったら新しい利用者を作って、ひもづく家族を追加する
      if (residentId != family.id) {
        targetResidents.push(targetResident);
        targetResident = this.createTargetWaiter(family);
        residentId = family.id;
      }
      // 利用者が変わらなければ利用者に家族を追加する
      else {
        const targetFamily = this.createTargetFamily(family);
        targetResident.families.push(targetFamily);
      }
    }
    // 最終の利用者を追加する
    targetResidents.push(targetResident);

    return targetResidents;
  }

  /**
   * ### 宛先で選択候補とする家族を取得する
   */
  public async getWaiterFamilies(): Promise<Array<WaiterFamiliesGetModel>> {
    const response: Array<WaiterFamiliesGetModel> = await this.waiterFamiliesService.getsInFacility(userStore);
    return response;
  }

  /**
   * ### 送信対象の利用者を作成する
   */
  public createTargetWaiter(family: WaiterFamiliesGetModel): SendMessageTargetResident {
    let target: SendMessageTargetResident = {
      id: family.id,
      birthday: family.birthday,
      facilityId: family.facilityId,
      gender: family.gender,
      password: family.password,
      name: family.name,
      kanaName: family.kanaName,
      tel: family.tel,
      room: family.room,
      groupId: family.groupId,
      show: true,
      families: []
    };
    target.families.push(this.createTargetFamily(family));

    return target;
  }

  /**
   * ### 送信対象の家族を作成する
   */
  public createTargetFamily(family: WaiterFamiliesGetModel): SendTargetFamily {
    let target: SendTargetFamily = {
      residentsSortKey: family.residentsSortKey,
      familyId: family.familyId ? family.familyId : 0,
      familyName: family.familyName ? family.familyName : "",
      familyTel: family.familyTel ? family.familyTel : "",
      familyLineId: family.familyLineId ? family.familyLineId : "",
      familyBirthDay: family.familyBirthDay ? family.familyBirthDay : 0,
      familyGender: family.familyGender ? family.familyGender : "",
      familyRelation: family.familyRelation ? family.familyRelation : "",
      familyPosition: family.familyPosition ? family.familyPosition : "",
      familyMailaddress: family.familyMailaddress ? family.familyMailaddress : "",
      senderType: family.senderType,
      show: true,
      isTarget: false
    };

    return target;
  }

  /**
   * ### 子コンポーネントでファイルが選択された場合のイベント処理
   *
   * - ファイルが上限数以上なら無視する
   * - バリデーションを行う
   * - バリデーションエラーでなければ、ファイルを親コンポーネントに渡す
   */
  public async inputFiles(files: Array<File>): Promise<void> {
    this.isLoading = true;
    this.loadingMessage = "読込み中...";

    const sendMessageFormCommonService: SendMessageFormCommonService = new SendMessageFormCommonService(this.$validator, "tempfiles-multiple-register-errors");
    const addFiles: Array<ExtDraggableFile> = await sendMessageFormCommonService.createAddFile(files, this.registerFileUploadLimit, this.files.length, this.needConvertPdf);

    this.isLoading = false;

    if (0 < addFiles.length) {
      this.files = this.files.concat(addFiles);

      for (let i = 0; i < this.files.length; i++) {
        this.files[i].key = i.toString();
      }
    }

    return;
  }

  /**
   * ### 指定されたファイルを削除する
   */
  public onFileDelete(index: number): void {
    this.files.splice(index, 1);
    return;
  }

  /**
   * ### 添付ファイルプレビューボタン押下イベント処理
   *
   * - ダイアログで添付ファイルをプレビュー表示する
   */
  public async onTempFilePreview(): Promise<void> {
    // ファイルを取得していないものがあったら取得する
    const files = [];
    for (const file of this.files) {
      this.isLoading = true;
      this.loadingMessage = "読込み中...";

      if (!file.fileObject) {
        file.fileObject = await this.getS3File(file.url as string, file.name);
        files.push(file.fileObject);
      } else {
        files.push(file.fileObject);
      }

      this.isLoading = false;
    }

    const modal: SendMessageFilePreviewModal | Vue | Element | Vue[] | Element[] = this.$refs.previewModal;
    if (modal instanceof SendMessageFilePreviewModal) {
      modal.show("", false, files);
    }

    return;
  }

  /**
   * ### メッセージ送信プレビュー
   */
  public async onMessagePreview(): Promise<void> {
    this.isLoading = true;
    this.loadingMessage = "読込み中...";

    const messageConfirmModal: SendMessageModal | Vue | Element | Vue[] | Element[] = this.$refs.messageConfirmModal;
    if (messageConfirmModal instanceof SendMessageModal) {
      const receivers: Array<LineReceiverDetail> = this.createMessagePreviewReceivers();
      const functionContents: SendMessageFunction = this.createMessagePreviewContents();
      messageConfirmModal.show(receivers, functionContents, false, false);
    }

    this.isLoading = false;

    return;
  }

  /**
   * ### 下書き保存の確認モーダルを表示する
   */
  public onSaveDraftMessage(): void {
    this.$validator.errors.remove("type");
    this.$validator.errors.remove("message-waiter-targets");
    this.$validator.errors.remove("message-title");
    this.$validator.errors.remove("text");
    if (!this.type) {
      this.$validator.errors.add({ field: "type", msg: "下書き保存の場合、宛先は必須項目です" });
      return;
    }

    this.showConfirmDraftMessageModal = true;

    return;
  }

  /**
   * ### 下書きを保存する
   */
  public saveDraftMessage(): void {
    const targets: string[] = this.createDraftMessagesTargets();

    this.setScreenInputTemporaryStore();
    const postModel: DraftMessagesPostModel = {
      type: this.type != "" ? Number(this.type) : undefined,
      targets: targets,
      title: this.title,
      content: this.text,
      addOptionText: this.addOptionText,
      addReadButton: this.addReadButton,
      addReplyButton: this.addReplyButton,
      files: []
    };

    if (this.draftMessageId == null) {
      this.$emit("saveDraftMessage", { draftMessagesModel: postModel, files: this.files, draftMessageId: this.draftMessageId });
    } else {
      let patchModel: DraftMessagesPatchModel = { ...postModel };
      patchModel.oldFiles = this.draftMessageOldFiles != null ? this.draftMessageOldFiles : undefined;
      patchModel.updated = this.draftMessageUpdated != null ? this.draftMessageUpdated : 0;
      this.$emit("saveDraftMessage", { draftMessagesModel: patchModel, files: this.files, draftMessageId: this.draftMessageId });
    }

    return;
  }

  /**
   * ### メッセージ下書きの宛先を作成する
   *
   * - 宛先種別に応じて宛先は可変になる
   *   - 申込者全員の場合は空配列
   *   - 申込者個別の場合は家族を特定するソートキー
   */
  public createDraftMessagesTargets(): string[] {
    let targets: string[] = [];

    switch (this.type) {
      // 申込者全員
      case "4": {
        break;
      }
      // 申込者個別
      case "5": {
        for (const waiter of this.waiterTargets) {
          for (let targetFamily of waiter.families) {
            if (targetFamily.isTarget) {
              targets.push(targetFamily.residentsSortKey);
            }
          }
        }
        break;
      }
    }

    return targets;
  }

  /**
   * ### メッセージ下書きの内容を復元する
   *
   * - input要素の内容を初期化する
   * - 宛先を復元する
   * - 復元した宛先に欠損がある場合はメッセージを表示する
   */
  public async restoreDraftMessage(draftMessage: DraftMessagesGetModel): Promise<void> {
    // async処理でPromiseメソッドを実行しないと画面表示が崩れるので空のPromiseメソッドを実行する
    await this.emptyProsess();

    this.isLoading = true;
    this.loadingMessage = "読込み中...";
    this.errorMessage = "";

    this.type = draftMessage.type != undefined ? `${draftMessage.type}` : "";
    this.title = draftMessage.title != undefined ? `${draftMessage.title}` : "";
    this.text = draftMessage.content != undefined ? `${draftMessage.content}` : "";
    this.files = [];
    this.addOptionText = draftMessage.addOptionText != undefined ? draftMessage.addOptionText : false;
    this.addReadButton = draftMessage.addReadButton != undefined ? draftMessage.addReadButton : false;
    this.addReplyButton = draftMessage.addReplyButton != undefined ? draftMessage.addReplyButton : false;
    this.draftMessageId = draftMessage.id;
    this.draftMessageOldFiles = draftMessage.files != undefined ? draftMessage.files : null;
    this.draftMessageUpdated = draftMessage.updated;

    if (this.type != "") {
      if (draftMessage.targets != undefined && 0 < draftMessage.targets.length) {
        let restoredCount: number = 0;

        switch (this.type) {
          // 待機者個別
          case "5": {
            let map: Map<string, string> = new Map<string, string>();
            for (const targetSortKey of draftMessage.targets) {
              map.set(targetSortKey, targetSortKey);
            }
            restoredCount = this.restoreWaiterFamilyTargets(map);
            break;
          }
          default: {
            break;
          }
        }

        if (restoredCount == 0) {
          this.errorMessage = "宛先が削除されています";
        } else if (restoredCount != draftMessage.targets.length) {
          this.errorMessage = "宛先が一部削除されています";
        }
      }
    }

    if (draftMessage.files != undefined) {
      const files: Array<ExtDraggableFile> = [];
      for (const file of draftMessage.files) {
        files.push({
          name: file.name,
          type: "existing",
          fileObject: undefined,
          url: file.url
        });
      }
      this.files = files;
    }

    this.isLoading = false;

    return;
  }

  public async emptyProsess(): Promise<void> {
    return new Promise((reject: Function) => {
      reject();
    });
  }

  public restoreWaiterFamilyTargets(restoreTargetMap: Map<string, string>): number {
    let restoredCount: number = 0;

    for (const waiter of this.waiterTargets) {
      for (let targetFamily of waiter.families) {
        const sortKey: string | undefined = restoreTargetMap.get(targetFamily.residentsSortKey);

        if (sortKey != undefined) {
          targetFamily.isTarget = true;
          restoredCount++;
        } else {
          targetFamily.isTarget = false;
        }
      }
    }

    return restoredCount;
  }

  /**
   * ### S3に格納されているFileを取得する
   *
   * @param url 元URL
   */
  public async getS3File(url: string, fileName: string): Promise<File> {
    const response: File = await this.s3UrlService.getFile(userStore, Setting.backets.imageExpireHour, url, fileName);
    return response;
  }

  /**
   * メッセージ送信確認モーダルを表示する
   * 先にバリデーションチェックし、OKなら確認モーダルを表示する
   */
  public async sendMessageConfirm(): Promise<void> {
    this.isLoading = true;
    this.loadingMessage = "読込み中...";

    this.$validator.errors.remove("type");
    this.$validator.errors.remove("message-waiter-targets");
    this.$validator.errors.remove("message-title");
    this.$validator.errors.remove("text");
    const validationResult: boolean = await this.$validator.validateAll();
    const fileValidationResult: boolean = this.validateFiles();
    // 宛先の必須チェックは個別で行う
    this.validMessageTargets();

    const _this: any = this;
    if (validationResult && fileValidationResult && !_this.errors.has("message-waiter-targets") && !_this.errors.has("type")) {
      const messageConfirmModal: SendMessageModal | Vue | Element | Vue[] | Element[] = this.$refs.messageConfirmModal;
      if (messageConfirmModal instanceof SendMessageModal) {
        this.showValidationAlert = false;
        const receivers: Array<LineReceiverDetail> = this.createMessagePreviewReceivers();
        const functionContents: SendMessageFunction = this.createMessagePreviewContents();
        messageConfirmModal.show(receivers, functionContents, true, this.type == "0" ? true : false);
      }
    } else {
      this.showValidationAlert = true;
    }

    this.isLoading = false;

    return;
  }

  /**
   * ### ファイルバリデーション
   *
   * - 何らかの原因でファイルが存在しないパターンがあったので、チェック処理を行う
   */
  public validateFiles(): boolean {
    for (const file of this.files) {
      if (!file || !file.name || (file.fileObject && file.fileObject.size == 0)) {
        this.$validator.errors.add({
          field: "tempfiles-multiple-register-errors",
          msg: `ファイルが破損等をしている可能性があり、ファイルを認識することができません。お手数ですが、再度選択し直してください。`
        });
        return false;
      }
    }
    return true;
  }

  /**
   * 送信時の宛先必須チェック
   */
  public validMessageTargets(): void {
    switch (this.type) {
      // 待機者全員
      case "4": {
        // 家族数をカウントして、0件以下ならエラーとして扱う
        if (this.allWaiterFamily.length <= 0) {
          this.$validator.errors.add({ field: "type", msg: "入所申込者ご家族が登録されていないため、メッセージを送ることができません" });
        }
        break;
      }
      // 待機者個別
      case "5": {
        // 送信対象をカウントして、0件以下ならエラーとして扱う
        let targetCount: number = 0;
        for (const waiter of this.waiterTargets) {
          for (const targetFamily of waiter.families) {
            if (targetFamily.isTarget) {
              targetCount++;
            }
          }
        }

        if (targetCount <= 0) {
          this.$validator.errors.add({ field: "message-waiter-targets", msg: "宛先は必須項目です" });
        }
        break;
      }
    }

    return;
  }

  /**
   * ### メッセージ送信プレビュー用の宛先リストを作成する
   */
  public createMessagePreviewReceivers(): Array<LineReceiverDetail> {
    // 宛先リストを作成する
    let receivers: Array<LineReceiverDetail> = [];
    switch (this.type) {
      // 申込者全員送信
      case "4": {
        const receiver: LineReceiverDetail = {
          name: "入所申込者全員",
          lineId: "",
          sortKey: "",
          room: "",
          residentName: "",
          residentKanaName: ""
        };
        receivers.push(receiver);
        break;
      }
      // 申込者個別送信
      case "5": {
        for (const waiter of this.waiterTargets) {
          for (const targetFamily of waiter.families) {
            if (targetFamily.isTarget) {
              const receiver: LineReceiverDetail = {
                name: targetFamily.senderType == SenderType.MAIL ? targetFamily.familyName + "（メール）" : targetFamily.familyName,
                lineId: "",
                sortKey: "",
                room: "",
                residentName: waiter.name,
                residentKanaName: waiter.kanaName
              };
              receivers.push(receiver);
            }
          }
        }
        break;
      }
    }

    return receivers;
  }

  /**
   * ### メッセージ送信プレビュー用のコンテンツを作成する
   */
  public createMessagePreviewContents(): SendMessageFunction {
    // プレビュー表示するメッセージ内容
    const functionContents: SendMessageFunction = {
      title: this.title,
      content: this.text,
      addReadButton: this.addReadButton,
      addOptionText: this.addOptionText,
      addReplyButton: this.addReplyButton,
      replyLimit: userStore.facility.messageSettings.replyLimit
    };

    return functionContents;
  }

  /**
   * メッセージ送信確認ダイアログのOK処理
   */
  public sendMessage(): void {
    // APIに渡すためのパラメータを作成する
    let targetName: string = "";
    const lineSortKeys: Array<string> = [];
    const mailSortKeys: Array<string> = [];

    switch (this.type) {
      // 待機者家族全員
      case "4": {
        for (const targetFamily of this.allWaiterFamily) {
          if (targetFamily.senderType == SenderType.LINE && targetFamily.familyLineId) {
            lineSortKeys.push(targetFamily.residentsSortKey);
          } else if (targetFamily.senderType == SenderType.MAIL && targetFamily.familyMailaddress) {
            mailSortKeys.push(targetFamily.residentsSortKey);
          }
        }
        targetName = "入所申込者家族全員";
        break;
      }
      // 待機者家族個別
      case "5": {
        const targetNames: string[] = [];
        for (const waiter of this.waiterTargets) {
          for (const targetFamily of waiter.families) {
            if (targetFamily.isTarget) {
              targetNames.push(targetFamily.familyName);

              if (targetFamily.senderType == SenderType.LINE) {
                lineSortKeys.push(targetFamily.residentsSortKey);
              } else {
                mailSortKeys.push(targetFamily.residentsSortKey);
              }
            }
          }
        }
        targetName = targetNames.join("、");
        break;
      }
    }

    this.setScreenInputTemporaryStore();

    // LINE送信パラメータを作成する、送信先が無い場合はundefinedを格納する
    const sendLineMessage: SendLineMessagesPostModel | undefined = {
      sortKeys: lineSortKeys,
      targetName: targetName,
      title: this.$stringUtil.convertYen(this.title),
      message: this.$stringUtil.convertYen(this.text),
      addOptionText: this.addOptionText,
      addReadButton: this.addReadButton,
      addReplyButton: this.addReplyButton,
      writerId: userStore.loginUser.userId,
      writtenBy: userStore.loginUser.name,
      fileUrls: [],
      fileNames: [],
      type: this.type
    };

    // メール送信パラメータを作成する、送信先が無い場合はundefinedを格納する
    const sendMailMessage: SendMailMessagesPostModel | undefined = {
      sortKeys: mailSortKeys,
      targetName: targetName,
      subject: this.$stringUtil.convertYen(this.title),
      text: this.$stringUtil.convertYen(this.text),
      addOptionText: this.addOptionText,
      addReadButton: this.addReadButton,
      addReplyButton: this.addReplyButton,
      writerId: userStore.loginUser.userId,
      writtenBy: userStore.loginUser.name,
      fileUrls: [],
      fileNames: [],
      type: this.type,
      addReceivedMessageUrl: true,
      needDbRegister: true
    };

    this.$emit("send", {
      sendLineMessage: 0 < lineSortKeys.length ? sendLineMessage : undefined,
      sendMailMessage: 0 < mailSortKeys.length ? sendMailMessage : undefined,
      files: this.files,
      draftMessageId: this.draftMessageId
    });

    return;
  }

  public showWaiterSelectModal() {
    // メモリ渡しだと値変更が共有されてしまう
    // 値変更後に「キャンセル」された場合に困るので、コピーしたものを渡す
    const copy: Array<SendMessageTargetResident> = JSON.parse(JSON.stringify(this.waiterTargets));
    const modal: any = this.$refs.sendWaiterSelectModal;
    modal.show(copy);
    return;
  }

  /**
   * 宛先選択モーダルでOKボタンイベント処理
   */
  public addSendWaiterTarget(targets: Array<SendMessageTargetResident>) {
    this.waiterTargets = targets;
    return;
  }

  public deleteWaiterTarget(target: SendTargetFamily) {
    target.isTarget = false;
    return;
  }

  /**
   * ## 見ましたのチェックボックス押下イベント
   *
   * - オプションテキストを強制的にfalseにする
   */
  public onAddReadCheck(): void {
    if (this.addReadButton == true) {
      this.addOptionText = false;
    }

    return;
  }

  public getSenderType(senderType: SenderType): string {
    if (senderType == SenderType.MAIL) {
      return "（メール）";
    } else {
      return "";
    }
  }

  /**
   * ### 画面入力情報をstoreから復元し、store情報を初期化する
   */
  public restoreScreenInputTemporaryStore(): void {
    if (screenInputTemporaryStore.url == PcUrl.WaiterSendMessage) {
      this.type = screenInputTemporaryStore.inputParams.type;
      this.waiterTargets = screenInputTemporaryStore.inputParams.waiterTargets;
      // 復元するとタイトルと本文が上書きされるので復元しない
      // this.templateId = screenInputTemporaryStore.inputParams.templateId;
      this.title = screenInputTemporaryStore.inputParams.title;
      this.text = screenInputTemporaryStore.inputParams.text;
      this.addOptionText = screenInputTemporaryStore.inputParams.addOptionText;
      this.addReadButton = screenInputTemporaryStore.inputParams.addReadButton;
      this.addReplyButton = screenInputTemporaryStore.inputParams.addReplyButton;
      this.files = screenInputTemporaryStore.inputParams.files;
      this.draftMessageId = screenInputTemporaryStore.inputParams.draftMessageId;
      this.draftMessageOldFiles = screenInputTemporaryStore.inputParams.draftMessageOldFiles;
      this.draftMessageUpdated = screenInputTemporaryStore.inputParams.draftMessageUpdated;
      this.needConvertPdf = screenInputTemporaryStore.inputParams.needConvertPdf;

      this.resetScreenInputTemporaryStore();
    }
    return;
  }

  /**
   * ### 画面入力情報のstoreをリセットする
   */
  public resetScreenInputTemporaryStore(): void {
    screenInputTemporaryStore.initializeScreenInputTemporary();
    return;
  }

  /**
   * ### 画面入力情報をstoreに格納する
   *
   * - 一時間無操作タイムアウト対策としてAPIリクエスト前にstoreに保存する
   */
  public setScreenInputTemporaryStore(): void {
    screenInputTemporaryStore.setScreenInputTemporary({
      url: PcUrl.WaiterSendMessage,
      inputParams: {
        type: this.type,
        waiterTargets: this.waiterTargets,
        templateId: this.templateId,
        title: this.title,
        text: this.text,
        addOptionText: this.addOptionText,
        addReadButton: this.addReadButton,
        addReplyButton: this.addReplyButton,
        files: this.files,
        existFile: 0 < this.files.length ? true : false,
        draftMessageId: this.draftMessageId,
        draftMessageOldFiles: this.draftMessageOldFiles,
        draftMessageUpdated: this.draftMessageUpdated,
        needConvertPdf: this.needConvertPdf
      }
    });
    return;
  }

  /**
   * ### vue lifecycle activated
   */
  public async activated(): Promise<void> {
    this.$validator.errors.clear();
    this.showValidationAlert = false;

    if (needRefreshesStore.sendWaiterMessage.sendMessages == true) {
      await this.createView();
      needRefreshesStore.sendWaiterMessage.sendMessages = false;
    }
    return;
  }

  /**
   * ### 登録可能なファイル数を返す
   */
  get _registerImageFilesLimit(): number {
    const limit: number = this.registerFileUploadLimit - this.files.length;
    return limit;
  }

  get _enablePreviewStatus(): boolean {
    return 0 < this.files.length ? true : false;
  }

  async deactivated() {
    await this.$validator.reset();
    this.$validator.errors.clear();
    this.showValidationAlert = false;
    return;
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";
@import "../../../styles/pc/_mixin.scss";

.send-message-form {
  .right-side {
    margin-left: auto;
  }

  .send-message-btn {
    width: 104px;
  }
  .send-targets {
    max-width: 600px;

    .send-target-select-btn {
      margin: 0 8px 4px 0;
    }
    .send-target {
      display: inline-block;
      padding: 7px;
      @include font(16px);
      margin: 0 8px 4px 0;
      border-radius: 3px;
      transition: all 0.2s;
      border: 1px solid $form-border-color;

      .target-name {
        margin: 0 8px 0 0 !important;
      }
      .delete-btn {
        margin: 0 !important;
        font-size: 14px !important;
      }
    }
  }
  #message-title {
    max-width: 600px;
    width: 600px;
  }
  #text {
    max-width: 600px;
    width: 600px;
  }
  // テキスト入力領域はリサイズできてしまうとレイアウトが崩れるためリサイズを不可にする
  textarea {
    resize: none;
  }

  // チェックボックスは横一列に並べる
  .checkboxs {
    .option-text {
      width: 240px !important;
      margin-right: 40px;
      border-right: 1px solid $form-border-color;
    }
    .register-row {
      width: 180px;
    }
    .option-button {
      margin-bottom: 10px !important;
    }
  }

  .need-convert-pdf {
    margin: 8px 0 8px 0;

    // 画像でセレクトボックスを表現するので、input要素自体は非表示にする
    input[type="checkbox"] {
      display: none;

      // input要素の代わりに画像つきのspanにする
      // 選択しているか否かで画像を切り替える
      // for属性でcheckboxと紐づかせたspan要素のclickで、チェックボックスの状態が変更される
      & + span {
        // チェックボックス画像が全て表示されるように高さを指定する
        height: 46px;
        // チェックボックス画像が文字より大きく、文字が縦中央揃えに出来ないので、paddingで上下余白を取って位置調整
        padding: 6px 0 0 40px;
        background: url("../../../assets/login-checkbox-off.png") no-repeat left center;
        // チェックボックス画像のサイズを指定
        // 正方形なので要素の高さと同じになる
        background-size: 32px 32px;
      }
      &:checked + span {
        background: url("../../../assets/login-checkbox-on.png") no-repeat left center;
        // チェックボックス画像のサイズを指定
        // 正方形なので要素の高さと同じになる
        background-size: 32px 32px;
      }
    }
    .text {
      margin: 0 !important;
    }
  }

  .box-footer {
    padding: 10px 0 0 0 !important;
  }

  // ボタン位置をテキスト入力領域に合わせる
  .register-footer {
    @media (max-width: 1540px) {
      // 添付ファイルが縦に回り込んだときはボタンの位置を入力コンテンツの右端と同じにする
      .buttons {
        max-width: 605px;
      }
    }
  }
}
</style>
